// How to put this app on the home screen, when the browser will not do it for us
// (#330).
//
// The install prompt the app can fire is `beforeinstallprompt`, and it exists in
// exactly one family of browsers. Everywhere else — Safari on iOS above all —
// the event never arrives, so both the dialog and the menu item were hidden and
// the product said NOTHING about installing. The user was left to know that the
// browser's own share menu can do it.
//
// The second half of the same problem: `pwaInstallDismissedForever` is written
// once and never cleared. A single "do not show again" removed the only path
// that did exist, permanently, on that device.
//
// So the menu entry is always offered while the app is not installed, and when
// there is no prompt to fire it explains the manual route for the browser the
// visitor is actually using.

export const PLATFORMS = {
  IOS: 'ios',
  ANDROID: 'android',
  DESKTOP: 'desktop',
}

const isIosDevice = (ua) => /iPad|iPhone|iPod/.test(ua)

// iPadOS 13+ reports the desktop Safari user agent, so the string alone cannot
// tell an iPad from a Mac. A touch-capable "Macintosh" is an iPad.
const isIpadPretendingToBeMac = (ua, maxTouchPoints) =>
  /Macintosh/.test(ua) && Number(maxTouchPoints) > 1

export function detectPlatform({ userAgent = '', maxTouchPoints = 0 } = {}) {
  if (isIosDevice(userAgent) || isIpadPretendingToBeMac(userAgent, maxTouchPoints)) {
    return PLATFORMS.IOS
  }
  if (/Android/.test(userAgent)) {
    return PLATFORMS.ANDROID
  }
  return PLATFORMS.DESKTOP
}

const STEPS = {
  [PLATFORMS.IOS]: {
    title: 'הוספה למסך הבית באייפון',
    // Named for what the icon looks like, not for what Apple calls it: the
    // person holding the phone is looking for a picture, not a term.
    steps: [
      'לחצו על כפתור השיתוף — הריבוע עם החץ כלפי מעלה, בתחתית המסך',
      'גללו ברשימה ובחרו "הוסף למסך הבית"',
      'לחצו "הוסף" בפינה העליונה',
    ],
    note: 'באייפון אין אפשרות להתקין את האפליקציה בלחיצה אחת — זו מגבלה של הדפדפן, וההוספה נעשית מהתפריט של ספארי.',
  },
  [PLATFORMS.ANDROID]: {
    title: 'הוספה למסך הבית באנדרואיד',
    steps: [
      'פתחו את תפריט הדפדפן — שלוש הנקודות או שלושת הקווים',
      'בחרו "הוסף לדף הבית" או "התקן אפליקציה"',
      'אשרו את ההוספה',
    ],
    note: null,
  },
  [PLATFORMS.DESKTOP]: {
    title: 'הוספה לשולחן העבודה',
    steps: [
      'פתחו את תפריט הדפדפן',
      'בחרו "התקן" או "הוסף לשולחן העבודה"',
    ],
    note: null,
  },
}

export function installInstructions(environment) {
  return STEPS[detectPlatform(environment)]
}
